<!-- Zweck: Stellt die HTML-Struktur für app dialogs sendmessage component im Frontend bereit. -->
<h1 mat-dialog-title>Nachricht senden</h1>
@if (current_user) {
  <div mat-dialog-content>
    <mat-form-field class="labelleft fullwidth">
      <mat-label>Titel</mat-label>
      <input (change)="changeData()" [(ngModel)]="label" matInput>
    </mat-form-field>
    <br>
      <mat-checkbox [(ngModel)]="is_popup">Als Popup anzeigen</mat-checkbox>
      <mat-checkbox [(ngModel)]="dismissable">Kann verworfen werden</mat-checkbox>
      <br>
        <svg-icon>{{icon}}</svg-icon>
        <mat-form-field class="labelleft fullwidth">
          <mat-label>Icon</mat-label>
          <mat-select (selectionChange)="changeData();" [(ngModel)]="icon" placeholder="">
            <mat-option value="nachricht">
              <svg-icon>nachricht</svg-icon>
              Nachricht
            </mat-option>
            <mat-option value="warning">
              <svg-icon>warning</svg-icon>
              Warnung
            </mat-option>
            <mat-option value="info">
              <svg-icon>info</svg-icon>
              Info
            </mat-option>
            <mat-option value="error">
              <svg-icon>error</svg-icon>
              Error
            </mat-option>
          </mat-select>
        </mat-form-field>
        <br>
          <mat-form-field class="labelleft fullwidth">
            <mat-label>Nachricht</mat-label>
            <textarea (change)="changeData()" [(ngModel)]="text" cdkAutosizeMinRows="7" cdkTextareaAutosize matInput
            placeholder=""></textarea>
          </mat-form-field>
          <br>
            <mat-form-field class="labelleft fullwidth">
              <mat-label>URL</mat-label>
              <input (change)="changeData()" [(ngModel)]="url" matInput placeholder="">
            </mat-form-field>
          </div>
        }
        <div align="center" mat-dialog-actions>
          <button (click)="send()" [disabled]="!send_ready" class="mat-raised-button bgprimary" mat-raised-button>
            Senden
          </button>
          <button (click)="cancel()" class="mat-raised-button" mat-raised-button>
            Abbrechen
          </button>
        </div>
